const icons = {};
icons.kadence = <svg width="20px" height="20px" viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg' fillRule='evenodd'
clipRule='evenodd' strokeLinejoin='round' strokeMiterlimit='1.414'>
    <g fillRule='nonzero'>
        <path d='M44.812,1.007l-41.624,45.986l0,-45.986l41.624,0Z' fill='#105c90'
        />
        <path d='M44.812,46.993l-41.624,-45.986l0,45.986l41.624,0Z' fill='#179cd4'
        />
    </g>
</svg>;
icons.kadenceCat = <svg width="20px" height="20px" viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg' fillRule='evenodd'
clipRule='evenodd' strokeLinejoin='round' strokeMiterlimit='1.414'>
    <path d='M40.145,6.164l-32.29,35.673l0,-35.673l32.29,0Z' fill='#105c90'
    fillRule='nonzero' />
    <path d='M40.145,41.836l-32.29,-35.673l0,35.673l32.29,0Z' fill='#179cd4'
    fillRule='nonzero' />
</svg>;
icons.kadenceBW = <svg width="20px" height="20px" viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg' fillRule='evenodd'
clipRule='evenodd' strokeLinejoin='round' strokeMiterlimit='1.414'>
    <path d='M40.145,6.164l-32.29,35.673l0,-35.673l32.29,0Z'
    fillOpacity='0.502' fillRule='nonzero' />
    <path d='M40.145,41.836l-32.29,-35.673l0,35.673l32.29,0Z'
    fillRule='nonzero' />
</svg>;
icons.kadenceNew = <svg
      width="20px" height="20px"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 600 600"
    >
      <path fill="none" d="M0 0H599.973V599.973H0z"></path>
      <path d="M439.942 522.147H313.963c-13.641 0-24.713-11.076-24.713-24.717 0-13.637 11.072-24.713 24.713-24.713h82.291c12.842-.881 23-11.59 23-24.652 0-13.641-11.072-24.713-24.714-24.713h-60.165v-.004H265.77c-13.619 0-24.679-11.057-24.679-24.677 0-13.623 11.06-24.683 24.679-24.683h15.545l-.032-.029h23.109c13.615 0 24.669-11.053 24.669-24.668 0-13.614-11.054-24.667-24.669-24.667h-58.123v-.022H124.381c-13.614 0-24.669-11.055-24.669-24.672 0-13.615 11.055-24.67 24.669-24.67h121.888v-.069h47.722c13.603 0 24.647-11.043 24.647-24.648 0-13.602-11.044-24.647-24.647-24.647h-10.877l.003-.003h-50.683c-13.621 0-24.679-11.06-24.679-24.679 0-13.622 11.058-24.682 24.679-24.682h117.032c.583 0 1.16.019 1.732.059h41.834c13.638 0 24.71-11.073 24.71-24.712s-11.072-24.711-24.71-24.711h-61.494c-12.797-.928-22.905-11.618-22.905-24.65 0-13.64 11.073-24.715 24.714-24.715h96.865c.107 0 .213 0 .327.003h114.213l-200.123 218.55 242.056 225.813h-146.09l-.033-.033a15.92 15.92 0 01-.62.011zm-237.121-49.43c13.593 0 24.628 11.035 24.628 24.625 0 13.594-11.035 24.625-24.628 24.625H112.45c-13.59 0-24.625-11.031-24.625-24.625 0-13.59 11.035-24.625 24.625-24.625h90.371zm-35.777-98.729c13.632 0 24.7 11.068 24.7 24.702 0 13.63-11.068 24.699-24.7 24.699-13.634 0-24.701-11.069-24.701-24.699 0-13.634 11.067-24.702 24.701-24.702zM37.987 275.26c13.634 0 24.702 11.067 24.702 24.702 0 13.631-11.068 24.699-24.702 24.699-13.632 0-24.699-11.068-24.699-24.699 0-13.635 11.067-24.702 24.699-24.702zm95.722-98.728c13.632 0 24.701 11.067 24.701 24.701 0 13.633-11.069 24.7-24.701 24.7s-24.702-11.067-24.702-24.7c0-13.634 11.07-24.701 24.702-24.701zm88.581-98.729c13.593 0 24.626 11.036 24.626 24.626 0 13.592-11.033 24.627-24.626 24.627h-57.124c-13.59 0-24.625-11.035-24.625-24.627 0-13.59 11.033-24.626 24.625-24.626h57.124z"></path>
    </svg>;
icons.kadenceCatNew = <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 600 600"
      width="20px" height="20px"
    >
      <path fill="none" d="M0 0H599.973V599.973H0z"></path>
      <clipPath id="_clip1">
        <path d="M0 0H599.973V599.973H0z"></path>
      </clipPath>
      <g clipPath="url(#_clip1)">
        <path
          fill="url(#_Linear2)"
          d="M417.195 432.951h-76.036c-8.233 0-14.916-6.629-14.916-14.793 0-8.162 6.683-14.791 14.916-14.791h49.668c7.751-.528 13.882-6.937 13.882-14.754 0-8.165-6.683-14.792-14.916-14.792h-36.314v-.002h-41.407c-8.221 0-14.896-6.618-14.896-14.769 0-8.153 6.675-14.773 14.896-14.773h9.382l-.02-.018h13.949c8.217 0 14.889-6.615 14.889-14.763 0-8.149-6.672-14.764-14.889-14.764h-35.082v-.013h-73.566c-8.218 0-14.89-6.617-14.89-14.766 0-8.149 6.672-14.766 14.89-14.766h73.566v-.041h28.804c8.21 0 14.876-6.609 14.876-14.752 0-8.141-6.666-14.751-14.876-14.751h-6.565l.001-.002h-30.59c-8.221 0-14.895-6.619-14.895-14.771 0-8.153 6.674-14.772 14.895-14.772h70.636c.353 0 .7.012 1.046.035h25.249c8.231 0 14.914-6.627 14.914-14.79s-6.683-14.79-14.914-14.79h-37.115c-7.724-.555-13.825-6.953-13.825-14.753 0-8.163 6.683-14.792 14.917-14.792h58.464c.064 0 .129 0 .197.002h68.935L359.668 297.813l146.096 135.151h-88.175l-.019-.019c-.125.004-.249.006-.375.006zm-143.117-29.584c8.204 0 14.864 6.604 14.864 14.738 0 8.136-6.66 14.739-14.864 14.739h-54.545c-8.202 0-14.863-6.603-14.863-14.739 0-8.134 6.661-14.738 14.863-14.738h54.545zm-21.594-59.09c8.228 0 14.908 6.624 14.908 14.784 0 8.158-6.68 14.782-14.908 14.782-8.229 0-14.909-6.624-14.909-14.782 0-8.16 6.68-14.784 14.909-14.784zm-77.894-59.09c8.229 0 14.909 6.624 14.909 14.785 0 8.158-6.68 14.782-14.909 14.782-8.228 0-14.908-6.624-14.908-14.782 0-8.161 6.68-14.785 14.908-14.785zm57.774-59.089c8.228 0 14.909 6.624 14.909 14.784 0 8.159-6.681 14.783-14.909 14.783-8.227 0-14.909-6.624-14.909-14.783 0-8.16 6.682-14.784 14.909-14.784zm53.465-59.09c8.204 0 14.863 6.605 14.863 14.739 0 8.135-6.659 14.74-14.863 14.74h-34.478c-8.203 0-14.863-6.605-14.863-14.74 0-8.134 6.659-14.739 14.863-14.739h34.478z"
        ></path>
        <path
          fill="url(#_Linear3)"
          d="M550.399 91.724h-21.233v-44.31H21.233v405.35h46.129v21.233H0V26.181h550.399v65.543z"
        ></path>
        <path
          fill="url(#_Linear4)"
          d="M599.992 74.285H49.593v447.816h550.399V74.285zM70.826 95.518v405.35h507.933V95.518H70.826z"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="_Linear2"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(-1.14062 496.352 -500.546 -1.15026 324.683 24.807)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#0073e6"></stop>
          <stop offset="1" stopColor="#005ab3"></stop>
        </linearGradient>
        <linearGradient
          id="_Linear3"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(90 117.517 143.001) scale(495.062)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#0073e6"></stop>
          <stop offset="1" stopColor="#005ab3"></stop>
        </linearGradient>
        <linearGradient
          id="_Linear4"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(90 136.627 162.04) scale(495.792)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#0073e6"></stop>
          <stop offset="1" stopColor="#005ab3"></stop>
        </linearGradient>
      </defs>
    </svg>;
    icons.visibility = <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 20 20"
    version="1.1"
    viewBox="0 0 20 20"
    xmlSpace="preserve"
  >
    <path d="M18.3 9.5C15 4.9 8.5 3.8 3.9 7.2c-1.2.9-2.2 2.1-3 3.4.2.4.5.8.8 1.2 3.3 4.6 9.6 5.6 14.2 2.4.9-.7 1.7-1.4 2.4-2.4.3-.4.5-.8.8-1.2-.3-.4-.5-.8-.8-1.1zm-8.2-2.3c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8-1.3.5-1.8 0-.5-1.3 0-1.8zm-.1 7.7c-3.1 0-6-1.6-7.7-4.2C3.5 9 5.1 7.8 7 7.2c-.7.8-1 1.7-1 2.7 0 2.2 1.7 4.1 4 4.1 2.2 0 4.1-1.7 4.1-4v-.1c0-1-.4-2-1.1-2.7 1.9.6 3.5 1.8 4.7 3.5-1.7 2.6-4.6 4.2-7.7 4.2z"></path>
  </svg>;
export default icons;
